import React from 'react';

export default function StormHaloSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
      <defs>
        <radialGradient id="stormCloud" cx="0.5" cy="0.4" r="0.6">
          <stop offset="0%" stopColor="#5C6BC0" />
          <stop offset="100%" stopColor="#1A237E" />
        </radialGradient>
      </defs>
      {/* Halo ring (storm above head) */}
      <ellipse cx="20" cy="10" rx="14" ry="3.5" fill="#283593" opacity="0.6" />
      {/* Cloud puffs around halo */}
      <circle cx="10" cy="9" r="4" fill="url(#stormCloud)" />
      <circle cx="16" cy="7" r="4.5" fill="url(#stormCloud)" />
      <circle cx="22" cy="7" r="4.5" fill="url(#stormCloud)" />
      <circle cx="28" cy="9" r="4" fill="url(#stormCloud)" />
      <circle cx="14" cy="11" r="3.5" fill="#3949AB" />
      <circle cx="25" cy="11" r="3.5" fill="#3949AB" />
      {/* Cloud highlight */}
      <ellipse cx="16" cy="6" rx="3" ry="1" fill="#9FA8DA" opacity="0.5" />
      {/* Lightning bolts hanging down */}
      <path d="M14 14 L12 18 L14 18 L12 22 Z" fill="#E040FB" />
      <path d="M14 14 L12 18 L14 18 L12 22 Z" fill="#FFEB3B" opacity="0.7" />
      <path d="M22 14 L20 19 L22 19 L20 24 Z" fill="#FFEB3B" />
      <path d="M28 14 L26 18 L28 18 L26 21 Z" fill="#FFEB3B" />
      {/* Spark dots */}
      <circle cx="18" cy="13" r="0.6" fill="#FFEB3B" />
      <circle cx="26" cy="13" r="0.5" fill="#E040FB" />
    </svg>
  );
}
